import { ETAPES_GUICHET, LIBELLES_ETAPES_GUICHET, type EtapeGuichet } from './etapes';
import styles from '../metier.module.css';

export function Progression({ courante }: { courante: EtapeGuichet }) {
  const i = ETAPES_GUICHET.indexOf(courante);
  return (
    <ol className={styles.progression} aria-label="Étapes du dépôt">
      {ETAPES_GUICHET.map((e, j) => (
        <li
          key={e}
          aria-current={e === courante ? 'step' : undefined}
          data-faite={j < i || undefined}
        >
          <span className="cc-mono">{j + 1}</span> {LIBELLES_ETAPES_GUICHET[e]}
        </li>
      ))}
    </ol>
  );
}
